"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popup = void 0;
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
require("./styles.scss");
const icons_1 = require("@components/icons");
const Popup = (props) => {
    const { onClose, children, isOpened, target = "popup-container" } = props;
    const container = document.getElementById(target);
    if (!isOpened || !container) {
        return null;
    }
    return react_dom_1.default.createPortal(react_1.default.createElement("div", { className: "c-popup" },
        react_1.default.createElement("div", { className: "c-popup__content-container" },
            react_1.default.createElement("div", { className: "c-popup__close-popup", onClick: onClose },
                react_1.default.createElement(icons_1.CrossIcon, { color: "#cfcfcf", hoverColor: "#469B71" })),
            react_1.default.createElement("div", { className: "c-popup__content" }, children))), container);
};
exports.Popup = Popup;
